import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { ActionsEnum, UpdateAccount, UpdateUser } from './account-data.actions';
import { Account } from './account.model';
import { User } from './user.model';

// feature name
export const FEATURE_NAME = 'account-data';

// state interface
export interface IState {
  account: Account;
  user: User;
}

// initial state
export const initialState: IState = {
  account: void 0,
  user: void 0,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.UPDATE_ACCOUNT]: function (
      state: IState,
      { payload }: UpdateAccount
    ): IState {
      return {
        ...state,
        account: payload.account,
      };
    },
    [ActionsEnum.UPDATE_USER]: function (
      state: IState,
      { payload }: UpdateUser
    ): IState {
      return {
        ...state,
        user: payload.user,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getAccount = createSelector(
  selectFeature,
  (state: IState) => state.account
);
export const getUser = createSelector(
  selectFeature,
  (state: IState) => state.user
);
